// src/Home.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import GlobalStyle from '../GlobalStyles';
import Banner from '../components/Banner';

import Section1 from '../components/Section1';
import Goal from '../components/Goal';
import DID from '../components/DID';
import DAO from '../components/DAO';
import RetroPGF from '../components/RetroPGF';
import Web3 from '../components/Web3';
import Activities from '../components/Activities';
import Information from '../components/Information';


import Footer from '../components/Footer';
import InfoBanner from '../components/InfoBanner';
import InfoCardNews from '../components/InfoCardNews';
import InfoCardActivities from '../components/InfoCardActivities';
import InfoAnnouncement from '../components/InfoAnnouncement';


const Container = styled.div`
  max-width: 100%;
  margin:0px;
  padding: 0px;
  background-color:#000000;
`;



function Home() {
  return (

    <Container>
   
        <Navbar />
        <Banner /> 
        <Section1 />
        <Goal />
        
        <DID />
        
        <DAO />
        
        <RetroPGF />
        
        <Web3 />

        <Activities />

        <Information />
        
        <Footer /> 
  
 
    </Container>

  );
}



export default Home;